import './styles.scss'

import {EditorProvider, EditorProviderProps} from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import {FC} from 'react'
import styled from 'styled-components'
import {MenuBar} from './MenuBar'
import TextAlign from '@tiptap/extension-text-align'

const StyledRichText = styled.div``

const extensions = [
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
]

interface RichTextProps extends EditorProviderProps {
  containerClassName?: string
}

export const RichText: FC<RichTextProps> = ({containerClassName, ...props}) => {
  return (
    <StyledRichText className={containerClassName}>
      <EditorProvider slotBefore={<MenuBar />} extensions={extensions} {...props}>
        {props.children}
      </EditorProvider>
    </StyledRichText>
  )
}
